import r from "./SVGs/activity.svg?url";
import o from "./SVGs/activity_data.svg?url";
import m from "./SVGs/add_calendar.svg?url";
import i from "./SVGs/add_cart.svg?url";
import t from "./SVGs/add_column_after.svg?url";
import e from "./SVGs/add_document.svg?url";
import s from "./SVGs/add_new_comment.svg?url";
import _ from "./SVGs/add_new_tag.svg?url";
import p from "./SVGs/add_row_after.svg?url";
import f from "./SVGs/add_text.svg?url";
import a from "./SVGs/add_user.svg?url";
import g from "./SVGs/address.svg?url";
import v from "./SVGs/airplane.svg?url";
import n from "./SVGs/airplay.svg?url";
import l from "./SVGs/alarm.svg?url";
import c from "./SVGs/alarm_clock.svg?url";
import d from "./SVGs/alert.svg?url";
import u from "./SVGs/alert_outline_circle.svg?url";
import h from "./SVGs/alert_outline_square.svg?url";
import b from "./SVGs/alert_solid_circle.svg?url";
import w from "./SVGs/alert_solid_square.svg?url";
import k from "./SVGs/alignment.svg?url";
import y from "./SVGs/anatomical_heart.svg?url";
import x from "./SVGs/apple.svg?url";
import q from "./SVGs/application.svg?url";
import z from "./SVGs/approve_document.svg?url";
import j from "./SVGs/apron.svg?url";
import I from "./SVGs/archive.svg?url";
import A from "./SVGs/arrival.svg?url";
import B from "./SVGs/arrow_hook.svg?url";
import C from "./SVGs/article_in_press.svg?url";
import D from "./SVGs/artificial_intelligence.svg?url";
import E from "./SVGs/ascend.svg?url";
import F from "./SVGs/atm.svg?url";
import G from "./SVGs/audio_book.svg?url";
import H from "./SVGs/audio_slides.svg?url";
import J from "./SVGs/author_collaboration.svg?url";
import K from "./SVGs/backspace.svg?url";
import L from "./SVGs/badminton.svg?url";
import M from "./SVGs/balloon.svg?url";
import N from "./SVGs/ballpoint_pen.svg?url";
import O from "./SVGs/bandage.svg?url";
import P from "./SVGs/bank.svg?url";
import Q from "./SVGs/banknote.svg?url";
import R from "./SVGs/bar_graph.svg?url";
import S from "./SVGs/barbecue.svg?url";
import T from "./SVGs/barbecue_fire.svg?url";
import U from "./SVGs/barbecue_utensils.svg?url";
import V from "./SVGs/barometer.svg?url";
import W from "./SVGs/baseball_glove.svg?url";
import X from "./SVGs/bathroom_scale.svg?url";
import Y from "./SVGs/bbq_apron.svg?url";
import Z from "./SVGs/bean.svg?url";
import $ from "./SVGs/beer.svg?url";
import rr from "./SVGs/benign_hematology.svg?url";
import or from "./SVGs/bicycle.svg?url";
import mr from "./SVGs/bike.svg?url";
import ir from "./SVGs/binocular.svg?url";
import tr from "./SVGs/bird.svg?url";
import er from "./SVGs/boiling_pan.svg?url";
import sr from "./SVGs/bold.svg?url";
import _r from "./SVGs/bold_text.svg?url";
import pr from "./SVGs/book.svg?url";
import fr from "./SVGs/bookmark.svg?url";
import ar from "./SVGs/books.svg?url";
import gr from "./SVGs/bowling.svg?url";
import vr from "./SVGs/box.svg?url";
import nr from "./SVGs/boxing_glove.svg?url";
import lr from "./SVGs/bread.svg?url";
import cr from "./SVGs/briefcase.svg?url";
import dr from "./SVGs/broccoli.svg?url";
import ur from "./SVGs/broken_bone.svg?url";
import hr from "./SVGs/browse_pages.svg?url";
import br from "./SVGs/bubble_chart.svg?url";
import wr from "./SVGs/bulleted_list.svg?url";
import kr from "./SVGs/bullseye.svg?url";
import yr from "./SVGs/business_man.svg?url";
import xr from "./SVGs/business_phone.svg?url";
import qr from "./SVGs/calculator.svg?url";
import zr from "./SVGs/calendar.svg?url";
import jr from "./SVGs/call_bell.svg?url";
import Ir from "./SVGs/call_center.svg?url";
import Ar from "./SVGs/camera.svg?url";
import Br from "./SVGs/camera_film.svg?url";
import Cr from "./SVGs/camp_fire.svg?url";
import Dr from "./SVGs/camper.svg?url";
import Er from "./SVGs/car.svg?url";
import Fr from "./SVGs/cardiology.svg?url";
import Gr from "./SVGs/cargoship.svg?url";
import Hr from "./SVGs/carrot.svg?url";
import Jr from "./SVGs/case_study.svg?url";
import Kr from "./SVGs/cash_register.svg?url";
import Lr from "./SVGs/caution.svg?url";
import Mr from "./SVGs/cfl.svg?url";
import Nr from "./SVGs/character_map.svg?url";
import Or from "./SVGs/charcoal.svg?url";
import Pr from "./SVGs/charge_battery.svg?url";
import Qr from "./SVGs/charge_mobile.svg?url";
import Rr from "./SVGs/charging_battery.svg?url";
import Sr from "./SVGs/check.svg?url";
import Tr from "./SVGs/check_calendar.svg?url";
import Ur from "./SVGs/check_clipboard.svg?url";
import Vr from "./SVGs/checklist.svg?url";
import Wr from "./SVGs/checkmark.svg?url";
import Xr from "./SVGs/cheese.svg?url";
import Yr from "./SVGs/chefs_hat.svg?url";
import Zr from "./SVGs/chemistry_search.svg?url";
import $r from "./SVGs/chess.svg?url";
import ro from "./SVGs/chicken_leg.svg?url";
import oo from "./SVGs/circle_map_view.svg?url";
import mo from "./SVGs/citatonbench.svg?url";
import io from "./SVGs/cited_by_66.svg?url";
import to from "./SVGs/cited_by_99.svg?url";
import eo from "./SVGs/city_bus.svg?url";
import so from "./SVGs/clinical_dentistry.svg?url";
import _o from "./SVGs/clinical_trial.svg?url";
import po from "./SVGs/clipping.svg?url";
import fo from "./SVGs/cloche.svg?url";
import ao from "./SVGs/clock.svg?url";
import go from "./SVGs/clockwise.svg?url";
import vo from "./SVGs/close_quotes.svg?url";
import no from "./SVGs/cloud.svg?url";
import lo from "./SVGs/cloud_download.svg?url";
import co from "./SVGs/cloud_folder.svg?url";
import uo from "./SVGs/cloud_upload.svg?url";
import ho from "./SVGs/clouds.svg?url";
import bo from "./SVGs/cocktail.svg?url";
import wo from "./SVGs/coffee_and_cream.svg?url";
import ko from "./SVGs/coffee_and_sugar.svg?url";
import yo from "./SVGs/coffee_bean.svg?url";
import xo from "./SVGs/coffee_can.svg?url";
import qo from "./SVGs/coffee_cups.svg?url";
import zo from "./SVGs/coffee_milk.svg?url";
import jo from "./SVGs/coffee_milk_can.svg?url";
import Io from "./SVGs/coffee_mug.svg?url";
import Ao from "./SVGs/coins.svg?url";
import Bo from "./SVGs/colander.svg?url";
import Co from "./SVGs/column_left.svg?url";
import Do from "./SVGs/column_middle.svg?url";
import Eo from "./SVGs/column_right.svg?url";
import Fo from "./SVGs/columns.svg?url";
import Go from "./SVGs/comb.svg?url";
import Ho from "./SVGs/comment.svg?url";
import Jo from "./SVGs/compare_saved_versions.svg?url";
import Ko from "./SVGs/compass.svg?url";
import Lo from "./SVGs/compass_navigate.svg?url";
import Mo from "./SVGs/computer.svg?url";
import No from "./SVGs/computer_2.svg?url";
import Oo from "./SVGs/computer_chip.svg?url";
import Po from "./SVGs/computer_mouse.svg?url";
import Qo from "./SVGs/concept.svg?url";
import Ro from "./SVGs/conferenceseries.svg?url";
import So from "./SVGs/confirmation_outline_circle.svg?url";
import To from "./SVGs/confirmation_outline_square.svg?url";
import Uo from "./SVGs/confirmation_solid_circle.svg?url";
import Vo from "./SVGs/confirmation_solid_square.svg?url";
import Wo from "./SVGs/connection.svg?url";
import Xo from "./SVGs/consultancy.svg?url";
import Yo from "./SVGs/containers.svg?url";
import Zo from "./SVGs/contract.svg?url";
import $o from "./SVGs/contract_horisontal.svg?url";
import rm from "./SVGs/contributor.svg?url";
import om from "./SVGs/cooking_tools.svg?url";
import mm from "./SVGs/corn.svg?url";
import im from "./SVGs/counter_clockwise.svg?url";
import tm from "./SVGs/countries.svg?url";
import em from "./SVGs/countries_edit.svg?url";
import sm from "./SVGs/country.svg?url";
import _m from "./SVGs/country_edit.svg?url";
import pm from "./SVGs/couple_of_people.svg?url";
import fm from "./SVGs/course.svg?url";
import am from "./SVGs/create_bibliography.svg?url";
import gm from "./SVGs/credit_card.svg?url";
import vm from "./SVGs/crop.svg?url";
import nm from "./SVGs/crosshair.svg?url";
import lm from "./SVGs/cruise_ship.svg?url";
import cm from "./SVGs/cucumber_slices.svg?url";
import dm from "./SVGs/cup_of_coffee.svg?url";
import um from "./SVGs/cursor.svg?url";
import hm from "./SVGs/cutlery.svg?url";
import bm from "./SVGs/cv.svg?url";
import wm from "./SVGs/dashboard.svg?url";
import km from "./SVGs/database.svg?url";
import ym from "./SVGs/dataset.svg?url";
import xm from "./SVGs/ddi_risk_calculator.svg?url";
import qm from "./SVGs/delete.svg?url";
import zm from "./SVGs/delete_calendar.svg?url";
import jm from "./SVGs/delete_cart.svg?url";
import Im from "./SVGs/delete_column.svg?url";
import Am from "./SVGs/delete_document.svg?url";
import Bm from "./SVGs/delete_row.svg?url";
import Cm from "./SVGs/delete_user.svg?url";
import Dm from "./SVGs/delivery_truck.svg?url";
import Em from "./SVGs/delivery_van.svg?url";
import Fm from "./SVGs/departure.svg?url";
import Gm from "./SVGs/dermatology.svg?url";
import Hm from "./SVGs/descend.svg?url";
import Jm from "./SVGs/diabetes.svg?url";
import Km from "./SVGs/dimension.svg?url";
import Lm from "./SVGs/direct_left.svg?url";
import Mm from "./SVGs/direct_right.svg?url";
import Nm from "./SVGs/directions.svg?url";
import Om from "./SVGs/disc.svg?url";
import Pm from "./SVGs/dish_washer.svg?url";
import Qm from "./SVGs/distinct.svg?url";
import Rm from "./SVGs/dna.svg?url";
import Sm from "./SVGs/do_not_disturb.svg?url";
import Tm from "./SVGs/doc.svg?url";
import Um from "./SVGs/doc_file.svg?url";
import Vm from "./SVGs/down.svg?url";
import Wm from "./SVGs/down_left.svg?url";
import Xm from "./SVGs/down_right.svg?url";
import Ym from "./SVGs/download.svg?url";
import Zm from "./SVGs/download_book.svg?url";
import $m from "./SVGs/download_cart.svg?url";
import ri from "./SVGs/download_file.svg?url";
import oi from "./SVGs/download_folder.svg?url";
import mi from "./SVGs/downwards_bar_chart.svg?url";
import ii from "./SVGs/downwards_line_chart.svg?url";
import ti from "./SVGs/drag.svg?url";
import ei from "./SVGs/drag_handle.svg?url";
import si from "./SVGs/drag_vertical.svg?url";
import _i from "./SVGs/drinking.svg?url";
import pi from "./SVGs/drop.svg?url";
import fi from "./SVGs/dumbbell.svg?url";
import ai from "./SVGs/duplicate_document.svg?url";
import gi from "./SVGs/duster.svg?url";
import vi from "./SVGs/dvd_player.svg?url";
import ni from "./SVGs/e_book.svg?url";
import li from "./SVGs/e_reader.svg?url";
import ci from "./SVGs/earbuds.svg?url";
import di from "./SVGs/education.svg?url";
import ui from "./SVGs/education_history.svg?url";
import hi from "./SVGs/efficacy_data.svg?url";
import bi from "./SVGs/egg.svg?url";
import wi from "./SVGs/egg_timer.svg?url";
import ki from "./SVGs/eggs.svg?url";
import yi from "./SVGs/eight_ball.svg?url";
import xi from "./SVGs/eject.svg?url";
import qi from "./SVGs/elevator.svg?url";
import zi from "./SVGs/ellipsis.svg?url";
import ji from "./SVGs/ellipsis_open.svg?url";
import Ii from "./SVGs/email.svg?url";
import Ai from "./SVGs/empowering_knowledge_b.svg?url";
import Bi from "./SVGs/empty_cart.svg?url";
import Ci from "./SVGs/empty_ehr.svg?url";
import Di from "./SVGs/emtree_taxonomy_browser.svg?url";
import Ei from "./SVGs/epub.svg?url";
import Fi from "./SVGs/equipment.svg?url";
import Gi from "./SVGs/era_field_of_research.svg?url";
import Hi from "./SVGs/era_person.svg?url";
import Ji from "./SVGs/era_portfolio.svg?url";
import Ki from "./SVGs/era_research_output.svg?url";
import Li from "./SVGs/eraser.svg?url";
import Mi from "./SVGs/erlenmeyer_flask.svg?url";
import Ni from "./SVGs/espresso.svg?url";
import Oi from "./SVGs/ethical_review.svg?url";
import Pi from "./SVGs/event.svg?url";
import Qi from "./SVGs/evergreen.svg?url";
import Ri from "./SVGs/exe.svg?url";
import Si from "./SVGs/exe_file.svg?url";
import Ti from "./SVGs/exercise.svg?url";
import Ui from "./SVGs/exercise_bike.svg?url";
import Vi from "./SVGs/expand.svg?url";
import Wi from "./SVGs/expand_horisontal.svg?url";
import Xi from "./SVGs/export_document.svg?url";
import Yi from "./SVGs/export_file.svg?url";
import Zi from "./SVGs/export_profile_orcid.svg?url";
import $i from "./SVGs/externalcollaborations.svg?url";
import rt from "./SVGs/externalorganisation.svg?url";
import ot from "./SVGs/externalperson.svg?url";
import mt from "./SVGs/extra_sugar.svg?url";
import it from "./SVGs/eye.svg?url";
import tt from "./SVGs/eye_care.svg?url";
import et from "./SVGs/eye_hidden.svg?url";
import st from "./SVGs/eyedropper.svg?url";
import _t from "./SVGs/eyelift.svg?url";
import pt from "./SVGs/facebook_logo.svg?url";
import ft from "./SVGs/facebook_messenger.svg?url";
import at from "./SVGs/facetime.svg?url";
import gt from "./SVGs/faers_data.svg?url";
import vt from "./SVGs/failed_outline_circle.svg?url";
import nt from "./SVGs/failed_outline_square.svg?url";
import lt from "./SVGs/failed_solid_circle.svg?url";
import ct from "./SVGs/failed_solid_square.svg?url";
import dt from "./SVGs/fan.svg?url";
import ut from "./SVGs/fast_forward.svg?url";
import ht from "./SVGs/favourite.svg?url";
import bt from "./SVGs/fax.svg?url";
import wt from "./SVGs/female_face.svg?url";
import kt from "./SVGs/female_user.svg?url";
import yt from "./SVGs/field_hockey.svg?url";
import xt from "./SVGs/figma.svg?url";
import qt from "./SVGs/figma_lines.svg?url";
import zt from "./SVGs/file.svg?url";
import jt from "./SVGs/filter.svg?url";
import It from "./SVGs/fingerprint.svg?url";
import At from "./SVGs/firewall.svg?url";
import Bt from "./SVGs/first_quarter_moon.svg?url";
import Ct from "./SVGs/fish.svg?url";
import Dt from "./SVGs/fishes.svg?url";
import Et from "./SVGs/five_die.svg?url";
import Ft from "./SVGs/flag.svg?url";
import Gt from "./SVGs/flame.svg?url";
import Ht from "./SVGs/flash.svg?url";
import Jt from "./SVGs/floorplan.svg?url";
import Kt from "./SVGs/flowchart_a.svg?url";
import Lt from "./SVGs/flowchart_b.svg?url";
import Mt from "./SVGs/focus.svg?url";
import Nt from "./SVGs/fog.svg?url";
import Ot from "./SVGs/folder.svg?url";
import Pt from "./SVGs/folder_in.svg?url";
import Qt from "./SVGs/folder_out.svg?url";
import Rt from "./SVGs/font.svg?url";
import St from "./SVGs/football.svg?url";
import Tt from "./SVGs/forbidden.svg?url";
import Ut from "./SVGs/forest_plot_graph.svg?url";
import Vt from "./SVGs/fork.svg?url";
import Wt from "./SVGs/forklift.svg?url";
import Xt from "./SVGs/form.svg?url";
import Yt from "./SVGs/fountain_pen.svg?url";
import Zt from "./SVGs/four_die.svg?url";
import $t from "./SVGs/fragile.svg?url";
import re from "./SVGs/fragile_cargo.svg?url";
import oe from "./SVGs/freezer.svg?url";
import me from "./SVGs/fridge.svg?url";
import ie from "./SVGs/fries.svg?url";
import te from "./SVGs/fuel.svg?url";
import ee from "./SVGs/fully_charged.svg?url";
import se from "./SVGs/funder.svg?url";
import _e from "./SVGs/funder_group.svg?url";
import pe from "./SVGs/funding.svg?url";
import fe from "./SVGs/fundingopportunity.svg?url";
import ae from "./SVGs/garage.svg?url";
import ge from "./SVGs/gastroenterology.svg?url";
import ve from "./SVGs/gender_neutral_face.svg?url";
import ne from "./SVGs/get_help.svg?url";
import le from "./SVGs/gif_file.svg?url";
import ce from "./SVGs/gift.svg?url";
import de from "./SVGs/glass_wash.svg?url";
import ue from "./SVGs/globe.svg?url";
import he from "./SVGs/globe_location.svg?url";
import be from "./SVGs/golf.svg?url";
import we from "./SVGs/gondola_lift.svg?url";
import ke from "./SVGs/graduation_hat.svg?url";
import ye from "./SVGs/grapes.svg?url";
import xe from "./SVGs/grass.svg?url";
import qe from "./SVGs/green_tag.svg?url";
import ze from "./SVGs/grid.svg?url";
import je from "./SVGs/group_of_people.svg?url";
import Ie from "./SVGs/group_of_researchers.svg?url";
import Ae from "./SVGs/guided_tour.svg?url";
import Be from "./SVGs/hail.svg?url";
import Ce from "./SVGs/hairdryer.svg?url";
import De from "./SVGs/half_heart.svg?url";
import Ee from "./SVGs/half_star.svg?url";
import Fe from "./SVGs/hamburger.svg?url";
import Ge from "./SVGs/hamburger_menu.svg?url";
import He from "./SVGs/hanger.svg?url";
import Je from "./SVGs/hard_drive.svg?url";
import Ke from "./SVGs/heart_mobile.svg?url";
import Le from "./SVGs/heart_shape.svg?url";
import Me from "./SVGs/helicopter.svg?url";
import Ne from "./SVGs/help.svg?url";
import Oe from "./SVGs/help_icon.svg?url";
import Pe from "./SVGs/help_outline_circle.svg?url";
import Qe from "./SVGs/help_outline_square.svg?url";
import Re from "./SVGs/help_solid_circle.svg?url";
import Se from "./SVGs/help_solid_square.svg?url";
import Te from "./SVGs/hierarchy.svg?url";
import Ue from "./SVGs/high_battery.svg?url";
import Ve from "./SVGs/highlight.svg?url";
import We from "./SVGs/highway_sign.svg?url";
import Xe from "./SVGs/home.svg?url";
import Ye from "./SVGs/home_institution.svg?url";
import Ze from "./SVGs/hook.svg?url";
import $e from "./SVGs/horizontal_bar_chart.svg?url";
import rs from "./SVGs/hospital.svg?url";
import os from "./SVGs/hot.svg?url";
import ms from "./SVGs/hot_chocolate_and_cream.svg?url";
import is from "./SVGs/hot_sauce.svg?url";
import ts from "./SVGs/hot_tea.svg?url";
import es from "./SVGs/house_sale.svg?url";
import ss from "./SVGs/hy_hart.svg?url";
import _s from "./SVGs/ice_coffee.svg?url";
import ps from "./SVGs/ice_cream.svg?url";
import fs from "./SVGs/ice_skate.svg?url";
import as from "./SVGs/idea.svg?url";
import gs from "./SVGs/impact.svg?url";
import vs from "./SVGs/import_document.svg?url";
import ns from "./SVGs/import_file.svg?url";
import ls from "./SVGs/inbox.svg?url";
import cs from "./SVGs/indent_for_list_items.svg?url";
import ds from "./SVGs/info.svg?url";
import us from "./SVGs/information.svg?url";
import hs from "./SVGs/information_outline_circle.svg?url";
import bs from "./SVGs/information_outline_square.svg?url";
import ws from "./SVGs/information_solid_circle.svg?url";
import ks from "./SVGs/information_solid_square.svg?url";
import ys from "./SVGs/insert_boxes.svg?url";
import xs from "./SVGs/insert_bulleted_list.svg?url";
import qs from "./SVGs/insert_code.svg?url";
import zs from "./SVGs/insert_coffee_cups.svg?url";
import js from "./SVGs/insert_formulas.svg?url";
import Is from "./SVGs/insert_header.svg?url";
import As from "./SVGs/insert_numbered_list.svg?url";
import Bs from "./SVGs/insert_paragraph.svg?url";
import Cs from "./SVGs/insert_question.svg?url";
import Ds from "./SVGs/insert_references.svg?url";
import Es from "./SVGs/institution.svg?url";
import Fs from "./SVGs/institution_edit.svg?url";
import Gs from "./SVGs/institution_ranking.svg?url";
import Hs from "./SVGs/institutions.svg?url";
import Js from "./SVGs/institutions_edit.svg?url";
import Ks from "./SVGs/interactive_case_insights.svg?url";
import Ls from "./SVGs/internet.svg?url";
import Ms from "./SVGs/island.svg?url";
import Ns from "./SVGs/italic.svg?url";
import Os from "./SVGs/italic_text.svg?url";
import Ps from "./SVGs/jelly_bean_graph.svg?url";
import Qs from "./SVGs/jerrycan.svg?url";
import Rs from "./SVGs/journal.svg?url";
import Ss from "./SVGs/journal_alt.svg?url";
import Ts from "./SVGs/jpg_file.svg?url";
import Us from "./SVGs/jumprope.svg?url";
import Vs from "./SVGs/key.svg?url";
import Ws from "./SVGs/kitchen_hood_1.svg?url";
import Xs from "./SVGs/kitchen_hood_2.svg?url";
import Ys from "./SVGs/knife.svg?url";
import Zs from "./SVGs/knob.svg?url";
import $s from "./SVGs/label.svg?url";
import r_ from "./SVGs/laptop.svg?url";
import o_ from "./SVGs/latte_macchiato_1.svg?url";
import m_ from "./SVGs/latte_macchiato_2.svg?url";
import i_ from "./SVGs/layers.svg?url";
import t_ from "./SVGs/layout.svg?url";
import e_ from "./SVGs/leaf.svg?url";
import s_ from "./SVGs/left.svg?url";
import __ from "./SVGs/left_right.svg?url";
import p_ from "./SVGs/legal_contract.svg?url";
import f_ from "./SVGs/lemon.svg?url";
import a_ from "./SVGs/lessonplan.svg?url";
import g_ from "./SVGs/light_snow.svg?url";
import v_ from "./SVGs/lightbulb.svg?url";
import n_ from "./SVGs/lightning.svg?url";
import l_ from "./SVGs/lightning_rain.svg?url";
import c_ from "./SVGs/line_chart.svg?url";
import d_ from "./SVGs/line_chart_clipboard.svg?url";
import u_ from "./SVGs/line_charts.svg?url";
import h_ from "./SVGs/link.svg?url";
import b_ from "./SVGs/linkedin.svg?url";
import w_ from "./SVGs/list.svg?url";
import k_ from "./SVGs/lithograph.svg?url";
import y_ from "./SVGs/loading.svg?url";
import x_ from "./SVGs/location.svg?url";
import q_ from "./SVGs/lock.svg?url";
import z_ from "./SVGs/lock_file.svg?url";
import j_ from "./SVGs/lock_folder.svg?url";
import I_ from "./SVGs/lock_mobile.svg?url";
import A_ from "./SVGs/locomotive.svg?url";
import B_ from "./SVGs/log_in.svg?url";
import C_ from "./SVGs/log_out.svg?url";
import D_ from "./SVGs/love.svg?url";
import E_ from "./SVGs/low_battery.svg?url";
import F_ from "./SVGs/luggage.svg?url";
import G_ from "./SVGs/male_face.svg?url";
import H_ from "./SVGs/man.svg?url";
import J_ from "./SVGs/map.svg?url";
import K_ from "./SVGs/map_location.svg?url";
import L_ from "./SVGs/matrix_view.svg?url";
import M_ from "./SVGs/measure.svg?url";
import N_ from "./SVGs/measuring_cup.svg?url";
import O_ from "./SVGs/medal.svg?url";
import P_ from "./SVGs/medical_cross.svg?url";
import Q_ from "./SVGs/medical_thermometer.svg?url";
import R_ from "./SVGs/medium_battery.svg?url";
import S_ from "./SVGs/megaphone.svg?url";
import T_ from "./SVGs/merge.svg?url";
import U_ from "./SVGs/merge_table_cells.svg?url";
import V_ from "./SVGs/metabolizing_enzymes_transporters.svg?url";
import W_ from "./SVGs/microphone.svg?url";
import X_ from "./SVGs/microwave.svg?url";
import Y_ from "./SVGs/milestone.svg?url";
import Z_ from "./SVGs/milestonetemplate.svg?url";
import $_ from "./SVGs/milk_bottle.svg?url";
import rp from "./SVGs/minisafe.svg?url";
import op from "./SVGs/minus.svg?url";
import mp from "./SVGs/mobile_dollar_payment.svg?url";
import ip from "./SVGs/mobile_euro_payment.svg?url";
import tp from "./SVGs/mobile_phone.svg?url";
import ep from "./SVGs/mobipocket.svg?url";
import sp from "./SVGs/molecular_models_3d.svg?url";
import _p from "./SVGs/money_bag.svg?url";
import pp from "./SVGs/money_withdrawal.svg?url";
import fp from "./SVGs/moon.svg?url";
import ap from "./SVGs/motorcycle.svg?url";
import gp from "./SVGs/move.svg?url";
import vp from "./SVGs/move_column_left.svg?url";
import np from "./SVGs/move_column_right.svg?url";
import lp from "./SVGs/move_content_down.svg?url";
import cp from "./SVGs/move_content_up.svg?url";
import dp from "./SVGs/move_row_down.svg?url";
import up from "./SVGs/move_row_up.svg?url";
import hp from "./SVGs/movie_folder.svg?url";
import bp from "./SVGs/moving_box.svg?url";
import wp from "./SVGs/moving_box_down.svg?url";
import kp from "./SVGs/moving_box_up.svg?url";
import yp from "./SVGs/mp3_file.svg?url";
import xp from "./SVGs/multiple_layers.svg?url";
import qp from "./SVGs/music.svg?url";
import zp from "./SVGs/musical_note.svg?url";
import jp from "./SVGs/navigate.svg?url";
import Ip from "./SVGs/navigate_down.svg?url";
import Ap from "./SVGs/navigate_left.svg?url";
import Bp from "./SVGs/navigate_right.svg?url";
import Cp from "./SVGs/navigate_up.svg?url";
import Dp from "./SVGs/navigation_device.svg?url";
import Ep from "./SVGs/navigation_mobile.svg?url";
import Fp from "./SVGs/needle.svg?url";
import Gp from "./SVGs/neuroimagery.svg?url";
import Hp from "./SVGs/neurology.svg?url";
import Jp from "./SVGs/new.svg?url";
import Kp from "./SVGs/new_item.svg?url";
import Lp from "./SVGs/newspaper.svg?url";
import Mp from "./SVGs/next_page.svg?url";
import Np from "./SVGs/no_editing.svg?url";
import Op from "./SVGs/no_entrance.svg?url";
import Pp from "./SVGs/no_smoking.svg?url";
import Qp from "./SVGs/no_snapshot.svg?url";
import Rp from "./SVGs/nonwrittenproduction.svg?url";
import Sp from "./SVGs/normalized_view.svg?url";
import Tp from "./SVGs/notebook.svg?url";
import Up from "./SVGs/notifications_disabled.svg?url";
import Vp from "./SVGs/numbered_list.svg?url";
import Wp from "./SVGs/office_building.svg?url";
import Xp from "./SVGs/olive_oil.svg?url";
import Yp from "./SVGs/oncology.svg?url";
import Zp from "./SVGs/one_die.svg?url";
import $p from "./SVGs/onion.svg?url";
import rf from "./SVGs/online_banking.svg?url";
import of from "./SVGs/open_book.svg?url";
import mf from "./SVGs/open_folder.svg?url";
import tf from "./SVGs/open_hand_right.svg?url";
import ef from "./SVGs/open_quotes.svg?url";
import sf from "./SVGs/orange.svg?url";
import _f from "./SVGs/orcid.svg?url";
import pf from "./SVGs/organisation.svg?url";
import ff from "./SVGs/outbox.svg?url";
import af from "./SVGs/outdent_for_list_items.svg?url";
import gf from "./SVGs/outlet.svg?url";
import vf from "./SVGs/oven.svg?url";
import nf from "./SVGs/page_curl.svg?url";
import lf from "./SVGs/paint_roller.svg?url";
import cf from "./SVGs/pan.svg?url";
import df from "./SVGs/pan_wash.svg?url";
import uf from "./SVGs/paper_shredder.svg?url";
import hf from "./SVGs/paperclip.svg?url";
import bf from "./SVGs/paprika.svg?url";
import wf from "./SVGs/passport.svg?url";
import kf from "./SVGs/pause.svg?url";
import yf from "./SVGs/pay_credit_card.svg?url";
import xf from "./SVGs/pdf_alternative.svg?url";
import qf from "./SVGs/pdf_download.svg?url";
import zf from "./SVGs/pdf_file.svg?url";
import jf from "./SVGs/pencil.svg?url";
import If from "./SVGs/pencil_disabled.svg?url";
import Af from "./SVGs/pepper_mill.svg?url";
import Bf from "./SVGs/person.svg?url";
import Cf from "./SVGs/person_filled.svg?url";
import Df from "./SVGs/personexpertise.svg?url";
import Ef from "./SVGs/pharmacokinetic.svg?url";
import Ff from "./SVGs/phdthesis.svg?url";
import Gf from "./SVGs/phone.svg?url";
import Hf from "./SVGs/phone_disabled.svg?url";
import Jf from "./SVGs/phone_mobile.svg?url";
import Kf from "./SVGs/photo.svg?url";
import Lf from "./SVGs/picnic_table.svg?url";
import Mf from "./SVGs/picture.svg?url";
import Nf from "./SVGs/picture_folder.svg?url";
import Of from "./SVGs/pie_chart.svg?url";
import Pf from "./SVGs/pie_chart_2.svg?url";
import Qf from "./SVGs/piggy_bank.svg?url";
import Rf from "./SVGs/pill.svg?url";
import Sf from "./SVGs/pill_bottle.svg?url";
import Tf from "./SVGs/pin.svg?url";
import Uf from "./SVGs/pin_note.svg?url";
import Vf from "./SVGs/pinned.svg?url";
import Wf from "./SVGs/pirate_ship.svg?url";
import Xf from "./SVGs/pixel.svg?url";
import Yf from "./SVGs/pizza.svg?url";
import Zf from "./SVGs/pizza_slice.svg?url";
import $f from "./SVGs/pizza_slice_2.svg?url";
import ra from "./SVGs/pizza_slicer.svg?url";
import oa from "./SVGs/placeholder.svg?url";
import ma from "./SVGs/plate_wash.svg?url";
import ia from "./SVGs/plates.svg?url";
import ta from "./SVGs/play.svg?url";
import ea from "./SVGs/play_video.svg?url";
import sa from "./SVGs/plug.svg?url";
import _a from "./SVGs/plus.svg?url";
import pa from "./SVGs/plus_outline_circle.svg?url";
import fa from "./SVGs/png_file.svg?url";
import aa from "./SVGs/pointing_left_up.svg?url";
import ga from "./SVGs/pointing_right.svg?url";
import va from "./SVGs/power_mobile.svg?url";
import na from "./SVGs/ppt.svg?url";
import la from "./SVGs/preservedreportdefinition.svg?url";
import ca from "./SVGs/preservedreportdefinition_alt.svg?url";
import da from "./SVGs/price_tag.svg?url";
import ua from "./SVGs/print.svg?url";
import ha from "./SVGs/printer.svg?url";
import ba from "./SVGs/printer_2.svg?url";
import wa from "./SVGs/prize.svg?url";
import ka from "./SVGs/project.svg?url";
import ya from "./SVGs/publication.svg?url";
import xa from "./SVGs/publication_set.svg?url";
import qa from "./SVGs/publication_sets.svg?url";
import za from "./SVGs/publisher.svg?url";
import ja from "./SVGs/pushpin.svg?url";
import Ia from "./SVGs/puzzle.svg?url";
import Aa from "./SVGs/quill.svg?url";
import Ba from "./SVGs/radio.svg?url";
import Ca from "./SVGs/radiology_3d.svg?url";
import Da from "./SVGs/rain.svg?url";
import Ea from "./SVGs/rainbow.svg?url";
import Fa from "./SVGs/rainbow_2.svg?url";
import Ga from "./SVGs/rapid_delivery.svg?url";
import Ha from "./SVGs/rar_file.svg?url";
import Ja from "./SVGs/read_online.svg?url";
import Ka from "./SVGs/realty_online.svg?url";
import La from "./SVGs/receipt.svg?url";
import Ma from "./SVGs/recent.svg?url";
import Na from "./SVGs/record.svg?url";
import Oa from "./SVGs/recurrence.svg?url";
import Pa from "./SVGs/recycle_cups.svg?url";
import Qa from "./SVGs/reddit.svg?url";
import Ra from "./SVGs/redirect.svg?url";
import Sa from "./SVGs/redo.svg?url";
import Ta from "./SVGs/ref_1b.svg?url";
import Ua from "./SVGs/ref_2.svg?url";
import Va from "./SVGs/ref_4a.svg?url";
import Wa from "./SVGs/ref_4b.svg?url";
import Xa from "./SVGs/ref_4c.svg?url";
import Ya from "./SVGs/ref_environment.svg?url";
import Za from "./SVGs/ref_impact.svg?url";
import $a from "./SVGs/ref_staff.svg?url";
import rg from "./SVGs/ref_uoa.svg?url";
import og from "./SVGs/refill.svg?url";
import mg from "./SVGs/refresh.svg?url";
import ig from "./SVGs/reload.svg?url";
import tg from "./SVGs/remove_calendar.svg?url";
import eg from "./SVGs/remove_cart.svg?url";
import sg from "./SVGs/remove_document.svg?url";
import _g from "./SVGs/remove_user.svg?url";
import pg from "./SVGs/repeat.svg?url";
import fg from "./SVGs/replay.svg?url";
import ag from "./SVGs/reply.svg?url";
import gg from "./SVGs/research_area.svg?url";
import vg from "./SVGs/research_area_edit.svg?url";
import ng from "./SVGs/research_areas.svg?url";
import lg from "./SVGs/research_areas_edit.svg?url";
import cg from "./SVGs/researcher.svg?url";
import dg from "./SVGs/researcher_profile_needs_action.svg?url";
import ug from "./SVGs/researcher_profile_updated.svg?url";
import hg from "./SVGs/reset.svg?url";
import bg from "./SVGs/reset_password.svg?url";
import wg from "./SVGs/resume.svg?url";
import kg from "./SVGs/retweet.svg?url";
import yg from "./SVGs/review.svg?url";
import xg from "./SVGs/reviewtemplate.svg?url";
import qg from "./SVGs/rewind.svg?url";
import zg from "./SVGs/ribbon.svg?url";
import jg from "./SVGs/right.svg?url";
import Ig from "./SVGs/rightward.svg?url";
import Ag from "./SVGs/road.svg?url";
import Bg from "./SVGs/rocket.svg?url";
import Cg from "./SVGs/romantic_book.svg?url";
import Dg from "./SVGs/rows.svg?url";
import Eg from "./SVGs/rss.svg?url";
import Fg from "./SVGs/rss_mobile.svg?url";
import Gg from "./SVGs/rubber_eraser.svg?url";
import Hg from "./SVGs/rubber_stamp.svg?url";
import Jg from "./SVGs/safe.svg?url";
import Kg from "./SVGs/safety_data.svg?url";
import Lg from "./SVGs/safety_margin.svg?url";
import Mg from "./SVGs/sailboat.svg?url";
import Ng from "./SVGs/salad.svg?url";
import Og from "./SVGs/salt.svg?url";
import Pg from "./SVGs/sausage.svg?url";
import Qg from "./SVGs/save_file.svg?url";
import Rg from "./SVGs/scale_down.svg?url";
import Sg from "./SVGs/scale_up.svg?url";
import Tg from "./SVGs/scales_of_justice.svg?url";
import Ug from "./SVGs/scanner.svg?url";
import Vg from "./SVGs/scatter_charts.svg?url";
import Wg from "./SVGs/screenshot.svg?url";
import Xg from "./SVGs/search.svg?url";
import Yg from "./SVGs/search_book.svg?url";
import Zg from "./SVGs/search_document.svg?url";
import $g from "./SVGs/search_house.svg?url";
import rv from "./SVGs/second_quarter_moon.svg?url";
import ov from "./SVGs/secondary_result.svg?url";
import mv from "./SVGs/secure_folder.svg?url";
import iv from "./SVGs/seedling.svg?url";
import tv from "./SVGs/selection_panel.svg?url";
import ev from "./SVGs/selection_panel_add.svg?url";
import sv from "./SVGs/selection_panel_add_2.svg?url";
import _v from "./SVGs/selection_panel_remove.svg?url";
import pv from "./SVGs/selection_panel_remove_2.svg?url";
import fv from "./SVGs/send.svg?url";
import av from "./SVGs/service.svg?url";
import gv from "./SVGs/settings.svg?url";
import vv from "./SVGs/settings_file.svg?url";
import nv from "./SVGs/share.svg?url";
import lv from "./SVGs/share_2.svg?url";
import cv from "./SVGs/shiney_glass.svg?url";
import dv from "./SVGs/shopping_bag.svg?url";
import uv from "./SVGs/shopping_basket.svg?url";
import hv from "./SVGs/shopping_cart.svg?url";
import bv from "./SVGs/shower.svg?url";
import wv from "./SVGs/shower_rain.svg?url";
import kv from "./SVGs/shrimp.svg?url";
import yv from "./SVGs/shuffle.svg?url";
import xv from "./SVGs/shuttle_bus.svg?url";
import qv from "./SVGs/six_die.svg?url";
import zv from "./SVGs/skip_back.svg?url";
import jv from "./SVGs/skip_forward.svg?url";
import Iv from "./SVGs/smart_phone.svg?url";
import Av from "./SVGs/smartphone.svg?url";
import Bv from "./SVGs/smoking.svg?url";
import Cv from "./SVGs/snapshot.svg?url";
import Dv from "./SVGs/snapshot_recurrence.svg?url";
import Ev from "./SVGs/snow_crystal.svg?url";
import Fv from "./SVGs/snow_fall.svg?url";
import Gv from "./SVGs/snowfall_2.svg?url";
import Hv from "./SVGs/snowflake.svg?url";
import Jv from "./SVGs/snowy_pine_tree.svg?url";
import Kv from "./SVGs/soccer.svg?url";
import Lv from "./SVGs/solar_panel.svg?url";
import Mv from "./SVGs/sort_ascending.svg?url";
import Nv from "./SVGs/sort_descending.svg?url";
import Ov from "./SVGs/sort_none.svg?url";
import Pv from "./SVGs/sound_high.svg?url";
import Qv from "./SVGs/sound_low.svg?url";
import Rv from "./SVGs/sound_medium.svg?url";
import Sv from "./SVGs/sound_off.svg?url";
import Tv from "./SVGs/source_branch.svg?url";
import Uv from "./SVGs/spaghetti.svg?url";
import Vv from "./SVGs/spaghetti_plate.svg?url";
import Wv from "./SVGs/speaker.svg?url";
import Xv from "./SVGs/spell_check.svg?url";
import Yv from "./SVGs/split_table_cells.svg?url";
import Zv from "./SVGs/spoon_fork.svg?url";
import $v from "./SVGs/square_add.svg?url";
import rn from "./SVGs/star.svg?url";
import on from "./SVGs/statistics.svg?url";
import mn from "./SVGs/stats.svg?url";
import tn from "./SVGs/steak.svg?url";
import en from "./SVGs/steam.svg?url";
import sn from "./SVGs/steering_wheel.svg?url";
import _n from "./SVGs/stethoscope.svg?url";
import pn from "./SVGs/stock.svg?url";
import fn from "./SVGs/stop.svg?url";
import an from "./SVGs/stop_gesture.svg?url";
import gn from "./SVGs/stopwatch.svg?url";
import vn from "./SVGs/stove.svg?url";
import nn from "./SVGs/strawberry.svg?url";
import ln from "./SVGs/street_location.svg?url";
import cn from "./SVGs/studentthesis.svg?url";
import dn from "./SVGs/subject_name_subcategory.svg?url";
import un from "./SVGs/subscript.svg?url";
import hn from "./SVGs/sugar.svg?url";
import bn from "./SVGs/suitcase.svg?url";
import wn from "./SVGs/sun.svg?url";
import kn from "./SVGs/sun_behind_cloud.svg?url";
import yn from "./SVGs/sunrise.svg?url";
import xn from "./SVGs/sunscreen.svg?url";
import qn from "./SVGs/sunset.svg?url";
import zn from "./SVGs/superscript.svg?url";
import jn from "./SVGs/supplements.svg?url";
import In from "./SVGs/swimming_pool.svg?url";
import An from "./SVGs/switch.svg?url";
import Bn from "./SVGs/sync.svg?url";
import Cn from "./SVGs/table_tennis.svg?url";
import Dn from "./SVGs/table_view.svg?url";
import En from "./SVGs/tables.svg?url";
import Fn from "./SVGs/tablet.svg?url";
import Gn from "./SVGs/tag.svg?url";
import Hn from "./SVGs/tape_measure.svg?url";
import Jn from "./SVGs/target.svg?url";
import Kn from "./SVGs/taxi.svg?url";
import Ln from "./SVGs/tea_bag.svg?url";
import Mn from "./SVGs/teddy_bear.svg?url";
import Nn from "./SVGs/temperature.svg?url";
import On from "./SVGs/temperature_falling.svg?url";
import Pn from "./SVGs/temperature_rising.svg?url";
import Qn from "./SVGs/tennis.svg?url";
import Rn from "./SVGs/text.svg?url";
import Sn from "./SVGs/text_box.svg?url";
import Tn from "./SVGs/text_file.svg?url";
import Un from "./SVGs/text_mobile.svg?url";
import Vn from "./SVGs/third_quarter_moon.svg?url";
import Wn from "./SVGs/this_side_up.svg?url";
import Xn from "./SVGs/three_die.svg?url";
import Yn from "./SVGs/thumbnails.svg?url";
import Zn from "./SVGs/thumbs_down.svg?url";
import $n from "./SVGs/thumbs_up.svg?url";
import rl from "./SVGs/tip.svg?url";
import ol from "./SVGs/to_end.svg?url";
import ml from "./SVGs/to_start.svg?url";
import il from "./SVGs/toaster.svg?url";
import tl from "./SVGs/top_results.svg?url";
import el from "./SVGs/topic.svg?url";
import sl from "./SVGs/topic_cluster.svg?url";
import _l from "./SVGs/topic_group.svg?url";
import pl from "./SVGs/topic_group_edit.svg?url";
import fl from "./SVGs/tornado.svg?url";
import al from "./SVGs/tractor.svg?url";
import gl from "./SVGs/traffic_camera.svg?url";
import vl from "./SVGs/traffic_light.svg?url";
import nl from "./SVGs/train.svg?url";
import ll from "./SVGs/train_tunnel.svg?url";
import cl from "./SVGs/trash.svg?url";
import dl from "./SVGs/tree.svg?url";
import ul from "./SVGs/triangle_down.svg?url";
import hl from "./SVGs/triangle_down_alt.svg?url";
import bl from "./SVGs/triangle_right.svg?url";
import wl from "./SVGs/triangle_right_alt.svg?url";
import kl from "./SVGs/tropical_fish.svg?url";
import yl from "./SVGs/truck.svg?url";
import xl from "./SVGs/tunnel.svg?url";
import ql from "./SVGs/turkey.svg?url";
import zl from "./SVGs/twinbed.svg?url";
import jl from "./SVGs/twitter.svg?url";
import Il from "./SVGs/two_die.svg?url";
import Al from "./SVGs/txt.svg?url";
import Bl from "./SVGs/umbrella.svg?url";
import Cl from "./SVGs/umbrella_rain.svg?url";
import Dl from "./SVGs/underline_text.svg?url";
import El from "./SVGs/undo.svg?url";
import Fl from "./SVGs/unlink.svg?url";
import Gl from "./SVGs/unlock.svg?url";
import Hl from "./SVGs/unpin.svg?url";
import Jl from "./SVGs/up.svg?url";
import Kl from "./SVGs/up_left.svg?url";
import Ll from "./SVGs/up_right.svg?url";
import Ml from "./SVGs/upload.svg?url";
import Nl from "./SVGs/upload_file.svg?url";
import Ol from "./SVGs/upload_folder.svg?url";
import Pl from "./SVGs/upwards_bar_chart.svg?url";
import Ql from "./SVGs/upwards_line_chart.svg?url";
import Rl from "./SVGs/urology.svg?url";
import Sl from "./SVGs/usb.svg?url";
import Tl from "./SVGs/user.svg?url";
import Ul from "./SVGs/user_profile.svg?url";
import Vl from "./SVGs/user_switch.svg?url";
import Wl from "./SVGs/vector.svg?url";
import Xl from "./SVGs/video_camera.svg?url";
import Yl from "./SVGs/video_camera_front.svg?url";
import Zl from "./SVGs/video_game.svg?url";
import $l from "./SVGs/view_author_documents.svg?url";
import rc from "./SVGs/vinyl_record.svg?url";
import oc from "./SVGs/virtual_microscope.svg?url";
import mc from "./SVGs/walking.svg?url";
import ic from "./SVGs/walky_talky.svg?url";
import tc from "./SVGs/warehouse.svg?url";
import ec from "./SVGs/warning_filled.svg?url";
import sc from "./SVGs/washing_machine.svg?url";
import _c from "./SVGs/watch.svg?url";
import pc from "./SVGs/water_cooker.svg?url";
import fc from "./SVGs/waterbottle.svg?url";
import ac from "./SVGs/weather.svg?url";
import gc from "./SVGs/weather_online.svg?url";
import vc from "./SVGs/weather_vane.svg?url";
import nc from "./SVGs/webcam.svg?url";
import lc from "./SVGs/wechat.svg?url";
import cc from "./SVGs/weibo.svg?url";
import dc from "./SVGs/weight.svg?url";
import uc from "./SVGs/weight_scale.svg?url";
import hc from "./SVGs/whatsapp.svg?url";
import bc from "./SVGs/wheelchair.svg?url";
import wc from "./SVGs/whisk.svg?url";
import kc from "./SVGs/wifi_book.svg?url";
import yc from "./SVGs/wifi_envelope.svg?url";
import xc from "./SVGs/wifi_open_book.svg?url";
import qc from "./SVGs/wind.svg?url";
import zc from "./SVGs/wind_vane.svg?url";
import jc from "./SVGs/wine_glass.svg?url";
import Ic from "./SVGs/woman.svg?url";
import Ac from "./SVGs/workspace.svg?url";
import Bc from "./SVGs/world.svg?url";
import Cc from "./SVGs/wrench.svg?url";
import Dc from "./SVGs/write_check.svg?url";
import Ec from "./SVGs/writing.svg?url";
import Fc from "./SVGs/x.svg?url";
import Gc from "./SVGs/x_axis.svg?url";
import Hc from "./SVGs/xls.svg?url";
import Jc from "./SVGs/xls_file.svg?url";
import Kc from "./SVGs/y_axis.svg?url";
import Lc from "./SVGs/yoga.svg?url";
import Mc from "./SVGs/youtube.svg?url";
import Nc from "./SVGs/zip_file.svg?url";
import Oc from "./SVGs/zoom_in.svg?url";
import Pc from "./SVGs/zoom_out.svg?url";
const B9 = {
  activity: r,
  "activity-data": o,
  "add-calendar": m,
  "add-cart": i,
  "add-column-after": t,
  "add-document": e,
  "add-new-comment": s,
  "add-new-tag": _,
  "add-row-after": p,
  "add-text": f,
  "add-user": a,
  address: g,
  airplane: v,
  airplay: n,
  alarm: l,
  "alarm-clock": c,
  alert: d,
  "alert-outline-circle": u,
  "alert-outline-square": h,
  "alert-solid-circle": b,
  "alert-solid-square": w,
  alignment: k,
  "anatomical-heart": y,
  apple: x,
  application: q,
  "approve-document": z,
  apron: j,
  archive: I,
  arrival: A,
  "arrow-hook": B,
  "article-in-press": C,
  "artificial-intelligence": D,
  ascend: E,
  atm: F,
  "audio-book": G,
  "audio-slides": H,
  "author-collaboration": J,
  backspace: K,
  badminton: L,
  balloon: M,
  "ballpoint-pen": N,
  bandage: O,
  bank: P,
  banknote: Q,
  "bar-graph": R,
  barbecue: S,
  "barbecue-fire": T,
  "barbecue-utensils": U,
  barometer: V,
  "baseball-glove": W,
  "bathroom-scale": X,
  "bbq-apron": Y,
  bean: Z,
  beer: $,
  "benign-hematology": rr,
  bicycle: or,
  bike: mr,
  binocular: ir,
  bird: tr,
  "boiling-pan": er,
  bold: sr,
  "bold-text": _r,
  book: pr,
  bookmark: fr,
  books: ar,
  bowling: gr,
  box: vr,
  "boxing-glove": nr,
  bread: lr,
  briefcase: cr,
  broccoli: dr,
  "broken-bone": ur,
  "browse-pages": hr,
  "bubble-chart": br,
  "bulleted-list": wr,
  bullseye: kr,
  "business-man": yr,
  "business-phone": xr,
  calculator: qr,
  calendar: zr,
  "call-bell": jr,
  "call-center": Ir,
  camera: Ar,
  "camera-film": Br,
  "camp-fire": Cr,
  camper: Dr,
  car: Er,
  cardiology: Fr,
  cargoship: Gr,
  carrot: Hr,
  "case-study": Jr,
  "cash-register": Kr,
  caution: Lr,
  cfl: Mr,
  "character-map": Nr,
  charcoal: Or,
  "charge-battery": Pr,
  "charge-mobile": Qr,
  "charging-battery": Rr,
  check: Sr,
  "check-calendar": Tr,
  "check-clipboard": Ur,
  checklist: Vr,
  checkmark: Wr,
  cheese: Xr,
  "chefs-hat": Yr,
  "chemistry-search": Zr,
  chess: $r,
  "chicken-leg": ro,
  "circle-map-view": oo,
  citatonbench: mo,
  "cited-by-66": io,
  "cited-by-99": to,
  "city-bus": eo,
  "clinical-dentistry": so,
  "clinical-trial": _o,
  clipping: po,
  cloche: fo,
  clock: ao,
  clockwise: go,
  "close-quotes": vo,
  cloud: no,
  "cloud-download": lo,
  "cloud-folder": co,
  "cloud-upload": uo,
  clouds: ho,
  cocktail: bo,
  "coffee-and-cream": wo,
  "coffee-and-sugar": ko,
  "coffee-bean": yo,
  "coffee-can": xo,
  "coffee-cups": qo,
  "coffee-milk": zo,
  "coffee-milk-can": jo,
  "coffee-mug": Io,
  coins: Ao,
  colander: Bo,
  "column-left": Co,
  "column-middle": Do,
  "column-right": Eo,
  columns: Fo,
  comb: Go,
  comment: Ho,
  "compare-saved-versions": Jo,
  compass: Ko,
  "compass-navigate": Lo,
  computer: Mo,
  "computer-2": No,
  "computer-chip": Oo,
  "computer-mouse": Po,
  concept: Qo,
  conferenceseries: Ro,
  "confirmation-outline-circle": So,
  "confirmation-outline-square": To,
  "confirmation-solid-circle": Uo,
  "confirmation-solid-square": Vo,
  connection: Wo,
  consultancy: Xo,
  containers: Yo,
  contract: Zo,
  "contract-horisontal": $o,
  contributor: rm,
  "cooking-tools": om,
  corn: mm,
  "counter-clockwise": im,
  countries: tm,
  "countries-edit": em,
  country: sm,
  "country-edit": _m,
  "couple-of-people": pm,
  course: fm,
  "create-bibliography": am,
  "credit-card": gm,
  crop: vm,
  crosshair: nm,
  "cruise-ship": lm,
  "cucumber-slices": cm,
  "cup-of-coffee": dm,
  cursor: um,
  cutlery: hm,
  cv: bm,
  dashboard: wm,
  database: km,
  dataset: ym,
  "ddi-risk-calculator": xm,
  delete: qm,
  "delete-calendar": zm,
  "delete-cart": jm,
  "delete-column": Im,
  "delete-document": Am,
  "delete-row": Bm,
  "delete-user": Cm,
  "delivery-truck": Dm,
  "delivery-van": Em,
  departure: Fm,
  dermatology: Gm,
  descend: Hm,
  diabetes: Jm,
  dimension: Km,
  "direct-left": Lm,
  "direct-right": Mm,
  directions: Nm,
  disc: Om,
  "dish-washer": Pm,
  distinct: Qm,
  dna: Rm,
  "do-not-disturb": Sm,
  doc: Tm,
  "doc-file": Um,
  down: Vm,
  "down-left": Wm,
  "down-right": Xm,
  download: Ym,
  "download-book": Zm,
  "download-cart": $m,
  "download-file": ri,
  "download-folder": oi,
  "downwards-bar-chart": mi,
  "downwards-line-chart": ii,
  drag: ti,
  "drag-handle": ei,
  "drag-vertical": si,
  drinking: _i,
  drop: pi,
  dumbbell: fi,
  "duplicate-document": ai,
  duster: gi,
  "dvd-player": vi,
  "e-book": ni,
  "e-reader": li,
  earbuds: ci,
  education: di,
  "education-history": ui,
  "efficacy-data": hi,
  egg: bi,
  "egg-timer": wi,
  eggs: ki,
  "eight-ball": yi,
  eject: xi,
  elevator: qi,
  ellipsis: zi,
  "ellipsis-open": ji,
  email: Ii,
  "empowering-knowledge-b": Ai,
  "empty-cart": Bi,
  "empty-ehr": Ci,
  "emtree-taxonomy-browser": Di,
  epub: Ei,
  equipment: Fi,
  "era-field-of-research": Gi,
  era_person: Hi,
  "era-portfolio": Ji,
  era_research_output: Ki,
  eraser: Li,
  "erlenmeyer-flask": Mi,
  espresso: Ni,
  "ethical-review": Oi,
  event: Pi,
  evergreen: Qi,
  exe: Ri,
  "exe-file": Si,
  exercise: Ti,
  "exercise-bike": Ui,
  expand: Vi,
  "expand-horisontal": Wi,
  "export-document": Xi,
  "export-file": Yi,
  "export-profile-orcid": Zi,
  externalcollaborations: $i,
  externalorganisation: rt,
  externalperson: ot,
  "extra-sugar": mt,
  eye: it,
  "eye-care": tt,
  "eye-hidden": et,
  eyedropper: st,
  eyelift: _t,
  "facebook-logo": pt,
  "facebook-messenger": ft,
  facetime: at,
  "faers-data": gt,
  "failed-outline-circle": vt,
  "failed-outline-square": nt,
  "failed-solid-circle": lt,
  "failed-solid-square": ct,
  fan: dt,
  "fast-forward": ut,
  favourite: ht,
  fax: bt,
  "female-face": wt,
  "female-user": kt,
  "field-hockey": yt,
  figma: xt,
  "figma-lines": qt,
  file: zt,
  filter: jt,
  fingerprint: It,
  firewall: At,
  "first-quarter-moon": Bt,
  fish: Ct,
  fishes: Dt,
  "five-die": Et,
  flag: Ft,
  flame: Gt,
  flash: Ht,
  floorplan: Jt,
  "flowchart-a": Kt,
  "flowchart-b": Lt,
  focus: Mt,
  fog: Nt,
  folder: Ot,
  "folder-in": Pt,
  "folder-out": Qt,
  font: Rt,
  football: St,
  forbidden: Tt,
  "forest-plot-graph": Ut,
  fork: Vt,
  forklift: Wt,
  form: Xt,
  "fountain-pen": Yt,
  "four-die": Zt,
  fragile: $t,
  "fragile-cargo": re,
  freezer: oe,
  fridge: me,
  fries: ie,
  fuel: te,
  "fully-charged": ee,
  funder: se,
  "funder-group": _e,
  funding: pe,
  fundingopportunity: fe,
  garage: ae,
  gastroenterology: ge,
  "gender-neutral-face": ve,
  "get-help": ne,
  "gif-file": le,
  gift: ce,
  "glass-wash": de,
  globe: ue,
  "globe-location": he,
  golf: be,
  "gondola-lift": we,
  "graduation-hat": ke,
  grapes: ye,
  grass: xe,
  "green-tag": qe,
  grid: ze,
  "group-of-people": je,
  "group-of-researchers": Ie,
  "guided-tour": Ae,
  hail: Be,
  hairdryer: Ce,
  "half-heart": De,
  "half-star": Ee,
  hamburger: Fe,
  "hamburger-menu": Ge,
  hanger: He,
  "hard-drive": Je,
  "heart-mobile": Ke,
  "heart-shape": Le,
  helicopter: Me,
  help: Ne,
  "help-icon": Oe,
  "help-outline-circle": Pe,
  "help-outline-square": Qe,
  "help-solid-circle": Re,
  "help-solid-square": Se,
  hierarchy: Te,
  "high-battery": Ue,
  highlight: Ve,
  "highway-sign": We,
  home: Xe,
  "home-institution": Ye,
  hook: Ze,
  "horizontal-bar-chart": $e,
  hospital: rs,
  hot: os,
  "hot-chocolate-and-cream": ms,
  "hot-sauce": is,
  "hot-tea": ts,
  "house-sale": es,
  "hy-hart": ss,
  "ice-coffee": _s,
  "ice-cream": ps,
  "ice-skate": fs,
  idea: as,
  impact: gs,
  "import-document": vs,
  "import-file": ns,
  inbox: ls,
  "indent-for-list-items": cs,
  "info-icon": ds,
  information: us,
  "information-outline-circle": hs,
  "information-outline-square": bs,
  "information-solid-circle": ws,
  "information-solid-square": ks,
  "insert-boxes": ys,
  "insert-bulleted-list": xs,
  "insert-code": qs,
  "insert-coffee-cups": zs,
  "insert-formulas": js,
  "insert-header": Is,
  "insert-numbered-list": As,
  "insert-paragraph": Bs,
  "insert-question": Cs,
  "insert-references": Ds,
  institution: Es,
  "institution-edit": Fs,
  "institution-ranking": Gs,
  institutions: Hs,
  "institutions-edit": Js,
  "interactive-case-insights": Ks,
  internet: Ls,
  island: Ms,
  italic: Ns,
  "italic-text": Os,
  "jelly-bean-graph": Ps,
  jerrycan: Qs,
  journal: Rs,
  "journal-alt": Ss,
  "jpg-file": Ts,
  jumprope: Us,
  key: Vs,
  "kitchen-hood-1": Ws,
  "kitchen-hood-2": Xs,
  knife: Ys,
  knob: Zs,
  label: $s,
  laptop: r_,
  "latte-macchiato-1": o_,
  "latte-macchiato-2": m_,
  layers: i_,
  layout: t_,
  leaf: e_,
  left: s_,
  "left-right": __,
  "legal-contract": p_,
  lemon: f_,
  lessonplan: a_,
  "light-snow": g_,
  lightbulb: v_,
  lightning: n_,
  "lightning-rain": l_,
  "line-chart": c_,
  "line-chart-clipboard": d_,
  "line-charts": u_,
  link: h_,
  linkedin: b_,
  list: w_,
  lithograph: k_,
  loading: y_,
  location: x_,
  lock: q_,
  "lock-file": z_,
  "lock-folder": j_,
  "lock-mobile": I_,
  locomotive: A_,
  "log-in": B_,
  "log-out": C_,
  love: D_,
  "low-battery": E_,
  luggage: F_,
  "male-face": G_,
  man: H_,
  map: J_,
  "map-location": K_,
  "matrix-view": L_,
  measure: M_,
  "measuring-cup": N_,
  medal: O_,
  "medical-cross": P_,
  "medical-thermometer": Q_,
  "medium-battery": R_,
  megaphone: S_,
  merge: T_,
  "merge-table-cells": U_,
  "metabolizing-enzymes-transporters": V_,
  microphone: W_,
  microwave: X_,
  milestone: Y_,
  milestonetemplate: Z_,
  "milk-bottle": $_,
  minisafe: rp,
  minus: op,
  "mobile-dollar-payment": mp,
  "mobile-euro-payment": ip,
  "mobile-phone": tp,
  mobipocket: ep,
  "molecular-models-3d": sp,
  "money-bag": _p,
  "money-withdrawal": pp,
  moon: fp,
  motorcycle: ap,
  move: gp,
  "move-column-left": vp,
  "move-column-right": np,
  "move-content-down": lp,
  "move-content-up": cp,
  "move-row-down": dp,
  "move-row-up": up,
  "movie-folder": hp,
  "moving-box": bp,
  "moving-box-down": wp,
  "moving-box-up": kp,
  "mp3-file": yp,
  "multiple-layers": xp,
  music: qp,
  "musical-note": zp,
  navigate: jp,
  "navigate-down": Ip,
  "navigate-left": Ap,
  "navigate-right": Bp,
  "navigate-up": Cp,
  "navigation-device": Dp,
  "navigation-mobile": Ep,
  needle: Fp,
  neuroimagery: Gp,
  neurology: Hp,
  new: Jp,
  "new-item": Kp,
  newspaper: Lp,
  "next-page": Mp,
  "no-editing": Np,
  "no-entrance": Op,
  "no-smoking": Pp,
  "no-snapshot": Qp,
  nonwrittenproduction: Rp,
  "normalized-view": Sp,
  notebook: Tp,
  "notifications-disabled": Up,
  "numbered-list": Vp,
  "office-building": Wp,
  "olive-oil": Xp,
  oncology: Yp,
  "one-die": Zp,
  onion: $p,
  "online-banking": rf,
  "open-book": of,
  "open-folder": mf,
  "open-hand-right": tf,
  "open-quotes": ef,
  orange: sf,
  orcid: _f,
  organisation: pf,
  outbox: ff,
  "outdent-for-list-items": af,
  outlet: gf,
  oven: vf,
  "page-curl": nf,
  "paint-roller": lf,
  pan: cf,
  "pan-wash": df,
  "paper-shredder": uf,
  paperclip: hf,
  paprika: bf,
  passport: wf,
  pause: kf,
  "pay-credit-card": yf,
  "pdf-alternative": xf,
  "pdf-download": qf,
  "pdf-file": zf,
  pencil: jf,
  "pencil-disabled": If,
  "pepper-mill": Af,
  person: Bf,
  person_filled: Cf,
  personexpertise: Df,
  pharmacokinetic: Ef,
  phdthesis: Ff,
  phone: Gf,
  "phone-disabled": Hf,
  "phone-mobile": Jf,
  photo: Kf,
  "picnic-table": Lf,
  picture: Mf,
  "picture-folder": Nf,
  "pie-chart": Of,
  "pie-chart-2": Pf,
  "piggy-bank": Qf,
  pill: Rf,
  "pill-bottle": Sf,
  pin: Tf,
  "pin-note": Uf,
  pinned: Vf,
  "pirate-ship": Wf,
  pixel: Xf,
  pizza: Yf,
  "pizza-slice": Zf,
  "pizza-slice-2": $f,
  "pizza-slicer": ra,
  placeholder: oa,
  "plate-wash": ma,
  plates: ia,
  play: ta,
  "play-video": ea,
  plug: sa,
  plus: _a,
  "plus-outline-circle": pa,
  "png-file": fa,
  "pointing-left-up": aa,
  "pointing-right": ga,
  "power-mobile": va,
  ppt: na,
  preservedreportdefinition: la,
  "preservedreportdefinition-alt": ca,
  "price-tag": da,
  print: ua,
  printer: ha,
  "printer-2": ba,
  prize: wa,
  project: ka,
  publication: ya,
  "publication-set": xa,
  "publication-sets": qa,
  publisher: za,
  pushpin: ja,
  puzzle: Ia,
  quill: Aa,
  radio: Ba,
  "radiology-3d": Ca,
  rain: Da,
  rainbow: Ea,
  "rainbow-2": Fa,
  "rapid-delivery": Ga,
  "rar-file": Ha,
  "read-online": Ja,
  "realty-online": Ka,
  receipt: La,
  recent: Ma,
  record: Na,
  recurrence: Oa,
  "recycle-cups": Pa,
  reddit: Qa,
  redirect: Ra,
  redo: Sa,
  ref_1b: Ta,
  ref_2: Ua,
  ref_4a: Va,
  ref_4b: Wa,
  ref_4c: Xa,
  ref_environment: Ya,
  ref_impact: Za,
  ref_staff: $a,
  ref_uoa: rg,
  refill: og,
  refresh: mg,
  reload: ig,
  "remove-calendar": tg,
  "remove-cart": eg,
  "remove-document": sg,
  "remove-user": _g,
  repeat: pg,
  replay: fg,
  reply: ag,
  "research-area": gg,
  "research-area-edit": vg,
  "research-areas": ng,
  "research-areas-edit": lg,
  researcher: cg,
  "researcher-profile-needs-action": dg,
  "researcher-profile-updated": ug,
  reset: hg,
  "reset-password": bg,
  resume: wg,
  retweet: kg,
  review: yg,
  reviewtemplate: xg,
  rewind: qg,
  ribbon: zg,
  right: jg,
  rightward: Ig,
  road: Ag,
  rocket: Bg,
  "romantic-book": Cg,
  rows: Dg,
  rss: Eg,
  "rss-mobile": Fg,
  "rubber-eraser": Gg,
  "rubber-stamp": Hg,
  safe: Jg,
  "safety-data": Kg,
  "safety-margin": Lg,
  sailboat: Mg,
  salad: Ng,
  salt: Og,
  sausage: Pg,
  "save-file": Qg,
  "scale-down": Rg,
  "scale-up": Sg,
  "scales-of-justice": Tg,
  scanner: Ug,
  "scatter-charts": Vg,
  screenshot: Wg,
  search: Xg,
  "search-book": Yg,
  "search-document": Zg,
  "search-house": $g,
  "second-quarter-moon": rv,
  "secondary-result": ov,
  "secure-folder": mv,
  seedling: iv,
  "selection-panel": tv,
  "selection-panel-add": ev,
  "selection-panel-add-2": sv,
  "selection-panel-remove": _v,
  "selection-panel-remove-2": pv,
  send: fv,
  service: av,
  settings: gv,
  "settings-file": vv,
  share: nv,
  "share-2": lv,
  "shiney-glass": cv,
  "shopping-bag": dv,
  "shopping-basket": uv,
  "shopping-cart": hv,
  shower: bv,
  "shower-rain": wv,
  shrimp: kv,
  shuffle: yv,
  "shuttle-bus": xv,
  "six-die": qv,
  "skip-back": zv,
  "skip-forward": jv,
  "smart-phone": Iv,
  smartphone: Av,
  smoking: Bv,
  snapshot: Cv,
  "snapshot-recurrence": Dv,
  "snow-crystal": Ev,
  "snow-fall": Fv,
  "snowfall-2": Gv,
  snowflake: Hv,
  "snowy-pine-tree": Jv,
  soccer: Kv,
  "solar-panel": Lv,
  "sort-ascending": Mv,
  "sort-descending": Nv,
  "sort-none": Ov,
  "sound-high": Pv,
  "sound-low": Qv,
  "sound-medium": Rv,
  "sound-off": Sv,
  "source-branch": Tv,
  spaghetti: Uv,
  "spaghetti-plate": Vv,
  speaker: Wv,
  "spell-check": Xv,
  "split-table-cells": Yv,
  "spoon-fork": Zv,
  square_add: $v,
  star: rn,
  statistics: on,
  stats: mn,
  steak: tn,
  steam: en,
  "steering-wheel": sn,
  stethoscope: _n,
  stock: pn,
  stop: fn,
  "stop-gesture": an,
  stopwatch: gn,
  stove: vn,
  strawberry: nn,
  "street-location": ln,
  studentthesis: cn,
  "subject-name-subcategory": dn,
  subscript: un,
  sugar: hn,
  suitcase: bn,
  sun: wn,
  "sun-behind-cloud": kn,
  sunrise: yn,
  sunscreen: xn,
  sunset: qn,
  superscript: zn,
  supplements: jn,
  "swimming-pool": In,
  switch: An,
  sync: Bn,
  "table-tennis": Cn,
  "table-view": Dn,
  tables: En,
  tablet: Fn,
  tag: Gn,
  "tape-measure": Hn,
  target: Jn,
  taxi: Kn,
  "tea-bag": Ln,
  "teddy-bear": Mn,
  temperature: Nn,
  "temperature-falling": On,
  "temperature-rising": Pn,
  tennis: Qn,
  text: Rn,
  "text-box": Sn,
  "text-file": Tn,
  "text-mobile": Un,
  "third-quarter-moon": Vn,
  "this-side-up": Wn,
  "three-die": Xn,
  thumbnails: Yn,
  "thumbs-down": Zn,
  "thumbs-up": $n,
  tip: rl,
  "to-end": ol,
  "to-start": ml,
  toaster: il,
  top_results: tl,
  topic: el,
  "topic-cluster": sl,
  "topic-group": _l,
  "topic-group-edit": pl,
  tornado: fl,
  tractor: al,
  "traffic-camera": gl,
  "traffic-light": vl,
  train: nl,
  "train-tunnel": ll,
  trash: cl,
  tree: dl,
  "triangle-down": ul,
  "triangle-down-alt": hl,
  "triangle-right": bl,
  "triangle-right-alt": wl,
  "tropical-fish": kl,
  truck: yl,
  tunnel: xl,
  turkey: ql,
  twinbed: zl,
  twitter: jl,
  "two-die": Il,
  txt: Al,
  umbrella: Bl,
  "umbrella-rain": Cl,
  "underline-text": Dl,
  undo: El,
  unlink: Fl,
  unlock: Gl,
  unpin: Hl,
  up: Jl,
  "up-left": Kl,
  "up-right": Ll,
  upload: Ml,
  "upload-file": Nl,
  "upload-folder": Ol,
  "upwards-bar-chart": Pl,
  "upwards-line-chart": Ql,
  urology: Rl,
  usb: Sl,
  user: Tl,
  "user-profile": Ul,
  "user-switch": Vl,
  vector: Wl,
  "video-camera": Xl,
  "video-camera-front": Yl,
  "video-game": Zl,
  "view-author-documents": $l,
  "vinyl-record": rc,
  "virtual-microscope": oc,
  walking: mc,
  "walky-talky": ic,
  warehouse: tc,
  warning_filled: ec,
  "washing-machine": sc,
  watch: _c,
  "water-cooker": pc,
  waterbottle: fc,
  weather: ac,
  "weather-online": gc,
  "weather-vane": vc,
  webcam: nc,
  wechat: lc,
  weibo: cc,
  weight: dc,
  "weight-scale": uc,
  whatsapp: hc,
  wheelchair: bc,
  whisk: wc,
  "wifi-book": kc,
  "wifi-envelope": yc,
  "wifi-open-book": xc,
  wind: qc,
  "wind-vane": zc,
  "wine-glass": jc,
  woman: Ic,
  workspace: Ac,
  world: Bc,
  wrench: Cc,
  "write-check": Dc,
  writing: Ec,
  x: Fc,
  "x-axis": Gc,
  xls: Hc,
  "xls-file": Jc,
  "y-axis": Kc,
  yoga: Lc,
  youtube: Mc,
  "zip-file": Nc,
  "zoom-in": Oc,
  "zoom-out": Pc
};
export {
  B9 as svgIcons
};
//# sourceMappingURL=svg-icons.js.map
